import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import teamGroup from "@/assets/team/team-group.png";
import { useTeam } from "@/lib/team";
import { useT, useMedia } from "@/lib/i18n";

export function TeamSection() {
  const { tk } = useT();
  const group = useMedia("home.team.group", teamGroup, "Equipo de RR Lex Juristas en el despacho");
  const team = useTeam();

  return (
    <section className="border-y border-gold/15 bg-card/30">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <div className="text-center mb-14">
          <span className="text-xs tracking-[0.4em] uppercase text-gold">
            {tk("home.team.kicker", "Nuestro Equipo")}
          </span>
          <h2 className="font-serif text-4xl md:text-5xl mt-4">
            {tk("home.team.title.a", "Las personas detrás de ")}
            <em className="not-italic gold-gradient">RR Lex Juristas</em>
          </h2>
          <p className="mt-6 text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            {tk(
              "home.team.subtitle",
              "Un equipo multidisciplinar liderado por Charlene Ramos Rodrigues, comprometido con una abogacía moderna, cercana y de excelencia técnica.",
            )}
          </p>
        </div>

        <div className="relative rounded-2xl overflow-hidden border border-gold/20 shadow-[0_30px_80px_-40px_rgba(0,0,0,0.6)]">
          <img
            src={group.url}
            alt={group.alt}
            className="w-full h-[420px] md:h-[560px] object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/30 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <div className="text-[10px] tracking-[0.35em] uppercase text-gold/90">
                {tk("home.team.group.kicker", "Despacho Sevilla & Camas")}
              </div>
              <div className="font-serif text-2xl md:text-3xl mt-2 text-foreground max-w-xl">
                {tk("home.team.group.line", "Seis profesionales, una sola vocación: defender tus derechos.")}
              </div>
            </div>
            <Link
              to="/about/equipo"
              className="self-start inline-flex items-center gap-3 rounded-full bg-gold text-primary-foreground px-6 py-3 text-xs tracking-[0.3em] uppercase hover:bg-[oklch(0.88_0.08_85)] transition-colors"
            >
              {tk("home.team.cta", "Conocer al equipo")} <ArrowRight size={14} />
            </Link>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {team.map((m) => (
            <Link
              key={m.slug}
              to="/about/equipo"
              hash={m.slug}
              className="group rounded-xl border border-gold/15 bg-background/60 overflow-hidden hover:border-gold/60 transition-colors"
            >
              <div className="aspect-[3/4] overflow-hidden bg-card flex items-end justify-center">
                <img
                  src={m.portrait.url}
                  alt={m.portrait.alt || m.name}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
              </div>
              <div className="p-4 text-center">
                <div className="font-serif text-sm leading-tight">{m.name}</div>
                <div className="text-[9px] tracking-[0.25em] uppercase text-gold/80 mt-2">{m.shortRole}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
